<template>
  <ParentPortal :tabs="sidePanelComponents">
    <router-view v-if="award"
                 :award="award"
                 class="main-content"/>
  </ParentPortal>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { IfacAwardDetails } from '@ifac/ui';
import awardsMixin from '@/mixins/awards/awards.mixin';
import ParentPortal from '@/views/components/portals/ParentPortal.vue';

export default {
  mixins: [awardsMixin],
  name: 'NominationsCreatePortal',
  components: {
    ParentPortal,
    IfacAwardDetails,
  },
  created() {
    this.mx_fetchAward();
  },
  data() {
    return {
      award: null,
    };
  },
  computed: {
    sidePanelComponents() {
      return [
        {
          icon: ['far', 'award'],
          headerText: 'Award',
          component: IfacAwardDetails,
          options: {
            award: this.award,
            isLoading: false,
          },
        },
      ];
    },
  },
};
</script>
